<template>
<div class="float-chat" v-on:click="split">
    <ul>
        <li class="social-media"><a href="#"><b-icon-instagram></b-icon-instagram></a></li>
        <li class="social-media"><a href="#"><b-icon-phone></b-icon-phone></a></li>
        <li class="social-media"><a href="#"><b-icon-twitter ></b-icon-twitter></a></li>
        <li class="social-media"><a href="#"><b-icon-github></b-icon-github></a></li>
    </ul>
</div>
</template>
<script>
import $ from 'jquery'
export default {
    name: 'float',
    methods: {
        split() {
            $(".float-chat").on("click", function(){
                $(".social-media").addClass("split-list")
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.float-chat {
    position: absolute;
    width: 70px;
    height: 200px;
    top: 48%;
    left: 0;
    ul {
        height: 200px;
        width: 50px;
        position: fixed;
        padding: 10px;
        position: fixed;
    }
    li.social-media {
       list-style-type: none;
       margin: 20px 0px;
    }
    .b-icon {
        color: rgb(48, 42, 42);
        width: 25px;
        height: 25px;
        z-index: 999;
        @media (max-width: 500px) {
            width: 20px;
            height: 20px;
        }
    }
    .b-icon:hover {
        animation-name: icon;
        animation-duration: 0.2s;
        animation-timing-function: ease-in-out;
    }
    @keyframes icon {
        0%   {transform: rotateZ(0deg);}
        25%  {transform: rotateZ(90deg);}
        50%  {transform: rotateZ(180deg);}
        75%  {transform: rotateZ(270deg);}
        100% {transform: rotateZ(360deg);}
    }
}
</style>